import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

import SingleWizard from './containers/SingleWizard';

const routes = [
    {
        type: 'simple',
        name: 'single-wizard',
        view: SingleWizard,
        path: '/single-wizard'
    }
]

export default ModuleBootstrapper.getRoutes('single-wizard', routes)
